
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#24b3ae',
        secondary: '#007B77',
        tertiary: '#007B77',
        mediumGrey: '#fefefe',
        grey: '#aaaaaa',
        background: '#eeeeee',
        accent: '#FF8E33',
        error: '#f55a4e',
        info: '#FF8E33',
        success: '#24b3ae',
        warning: '#FF8E33',
      },
    },
  },
});
